import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiService } from 'src/app/api.service';

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
})
export class TooltipComponent implements OnInit {

  @Input() text: string
  @Input() hideSettingName: string

  @Output() onDismiss = new EventEmitter()

  constructor(private api: ApiService) { }

  ngOnInit() {}

  dismiss() {
    if (this.hideSettingName) {
      this.api.postUpdateAppSettings({ [this.hideSettingName]: true })
    }
    this.onDismiss.emit()
  }
}
